<template>
  <div class="bg-white">
    <OrderInfo :order="order"></OrderInfo>
  </div>
</template>
<script>
import store from '@/modules'
import OrderInfo from '../../components/OrderInfo'

export default {
  data() {
    return {
      order: {company: {}}
    }
  },
  components: {
    OrderInfo
  },
  created() {
    store.dispatch('order/getOrderById', {id: this.$route.query.id}).then(payload => this.order = payload)
  }
}
</script>
